import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisRequest = ApiDefinition['/reviews']['PUT'];
type Input = ThisRequest['body'];
type Output = ThisRequest['response'];

const editProductReview = async (payload: Input): Promise<Output> => {
  const response = await noodleApiClient.put('/reviews', payload);
  return response.data;
};

export default editProductReview;
